import { useMemo, useState } from "react";
import { ChildrenProps } from "../../types";
import { ReconciliationContext } from "./Reconciliation.context";

export const ReconciliationContextProvider: React.FC<ChildrenProps> = ({
    children,
}) => {
    const [
        financialTransactionsToRemoveIds,
        setFinancialTransactionsToRemoveIds,
    ] = useState<number[]>([]);
    const [statementTransactionsToAddIds, setStatementTransactionsToAddIds] =
        useState<string[]>([]);

    const registerFinancialTransactionToRemove = (id: number) => {
        setFinancialTransactionsToRemoveIds((prev) => [...prev, id]);
    };

    const registerStatementTransactionToAdd = (id: string) => {
        setStatementTransactionsToAddIds((prev) => [...prev, id]);
    };

    const unregisterFinancialTransactionToRemove = (id: number) => {
        setFinancialTransactionsToRemoveIds((prev) =>
            prev.filter((i) => i !== id),
        );
    };

    const unregisterStatementTransactionToAdd = (id: string) => {
        setStatementTransactionsToAddIds((prev) =>
            prev.filter((i) => i !== id),
        );
    };

    const value = useMemo(
        () => ({
            financialTransactionsToRemoveIds,
            statementTransactionsToAddIds,
            registerFinancialTransactionToRemove,
            registerStatementTransactionToAdd,
            unregisterFinancialTransactionToRemove,
            unregisterStatementTransactionToAdd,
        }),
        [financialTransactionsToRemoveIds, statementTransactionsToAddIds],
    );

    return (
        <ReconciliationContext.Provider value={value}>
            {children}
        </ReconciliationContext.Provider>
    );
};
